import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

i18n.use(initReactI18next).init({
  fallbackLng: 'al',
  lng: 'al',
  resources: {
    al: {
      translations: require('./i18n/locales/al/translations.json')
    },
    en: {
      translations: require('./i18n/locales/en/translations.json')
    }
  },
  ns: ['translations'],
  defaultNS: 'translations'
})

i18n.languages = ['en', 'al']

export default i18n
